import { render, staticRenderFns } from "./formModeloDesafio.vue?vue&type=template&id=0a02f22d&"
import script from "./formModeloDesafio.vue?vue&type=script&lang=js&"
export * from "./formModeloDesafio.vue?vue&type=script&lang=js&"
import style0 from "./formModeloDesafio.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports